import axios from 'axios';

export const queryPython = async (input) => {
  try {
    const response = await axios.post('https://flask-server-39cf.onrender.com/query', { query: input });
    return response.data;
  } catch (error) {
    console.error('Error querying Python backend:', error);
    throw error;
  }
};
